import React from "react";
import "./ruko.scss";
import image from "../../media/logo/crystal.webp";
import image1 from "../../media/partruko.png";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import brosureimages from "./carousel-brosure.js";
import Cardruko from "./cardruko/cardruko.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

const ruko = () => {
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768, // Adjust breakpoint for your mobile size
        settings: {
          slidesToShow: 1, // Show only 1 slide on mobile screens
        },
      },
    ],
  };
  const nup = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6289510613901&text=Halo+della%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20ruko%20ini%20(NUP)%20https://marketingsummabekasi.id/&type=phone_number&app_absent=0";
    window.location.href = whatsappLink;
  };
  return (
    <div className="container-ruko">
      <div className="devider">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="divider-img-691399"
          viewBox="0 0 1010 137"
          preserveAspectRatio="none"
        >
          <path
            d="M 0,137 V 59.03716 c 158.97703,52.21241 257.17659,0.48065 375.35967,2.17167 118.18308,1.69101 168.54911,29.1665 243.12679,30.10771 C 693.06415,92.25775 855.93515,29.278599 1080,73.61449 V 137 Z"
            style={{ opacity: "1" }}
          ></path>
          <path
            d="M 0,10.174557 C 83.419822,8.405668 117.65911,41.78116 204.11379,44.65308 290.56846,47.52499 396.02558,-7.4328 620.04248,94.40134 782.19141,29.627636 825.67279,15.823104 1080,98.55518 V 137 H 0 Z"
            style={{ opacity: 0.5 }}
          ></path>
          <path
            d="M 0,45.10182 C 216.27861,-66.146913 327.90348,63.09813 416.42665,63.52904 504.94982,63.95995 530.42054,22.125806 615.37532,25.210412 700.33012,28.295019 790.77619,132.60682 1080,31.125744 V 137 H 0 Z"
            style={{ opacity: 0.25 }}
          ></path>
        </svg>
      </div>
      {/* <div className="judulnew"> NEW LAUNCHING</div> */}
      <div className="subjudulnew"> Ruko Crystal Boulevard 2</div>
      <div id="ruko" className="logo-ruko">
        <img className="logo" src={image} alt="ruko-crystal" />
      </div>
      <div className="containertambahan">
        {/* <div id="pendaftaran" className="container-benefit">
          <div className="judulbenefit"> Informasi Pendaftaran NUP:</div>
          <div className="listbenefit">
            <div className="benefit1">
              {" "}
              <FontAwesomeIcon icon={faCheck} /> Pendaftaran Prioritas Brand By
              Proposal
            </div>
            <div className="benefit1">
              {" "}
              <FontAwesomeIcon icon={faCheck} /> Pendaftaran Prioritas Unit
              Gandeng
            </div>
            <div className="benefit1">
              {" "}
              <FontAwesomeIcon icon={faCheck} /> Pendaftaran Prioritas No Urut
              Tanpa Undi
            </div>
            <div className="benefit1">
              {" "}
              <FontAwesomeIcon icon={faCheck} /> Pendaftaran No Urut Tanpa Undi
            </div>
            <button onClick={nup} className="wanup">
              <FontAwesomeIcon icon={faWhatsapp} />
              &nbsp; Pendaftaran NUP{" "}
            </button>
          </div>
        </div> */}
        <div className="a">
          <div className="desk-ruko">
            <div className="judul-desk-ruko">
              Signature Commercial Crystal Boulevard
            </div>
            <div className="ket">
              Crystal Boulevard Summarecon Bekasi adalah sebuah area komersial
              terbaru dan bernilai tinggi yang terletak di area bundaran
              Landmark Summarecon Bekasi. Bangunan Crystal Boulevard dirancang
              dengan high ceiling dan tata ruang yang optimal, serta koridor
              lebar di lantai dasar dan outdoor sky terrace. Crystal Boulevard
              Signature Commercial dilengkapi dengan 500 lot loaded parking
              ganda serta CCTV 24 jam yang memberikan rasa aman untuk tenant dan
              mitra. Area ini cocok untuk berbagai jenis usaha, seperti
              restoran, kafe, toko, dan lain-lain.
            </div>
          </div>
        </div>
      </div>
      <div className="container-desk-ruko">
        <div className="carousel-desk-ruko">
          <div>
            <Slider {...settings}>
              {brosureimages.map((image, index) => (
                <div>
                  <img
                    className="image-ruko"
                    key={index}
                    src={image}
                    alt="foto Banner"
                  />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
      <div>
        <Cardruko />
      </div>
      <div className="sewa-ruko">
        <img className="image-sewa-ruko" src={image1} alt="ruko-crystal" />
      </div>
    </div>
  );
};

export default ruko;
